import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, PageEvent } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, Subscriber } from 'rxjs';
import swal from 'sweetalert2';
import { Filtro } from '../models/filtro';
import { FormaDePagamento } from '../models/forma-de-pagamento';
import { CarregandoService } from '../services/carregando.service';
import { FormaDePagamentoService } from '../services/forma-de-pagamento.service';
import { GlobalService } from '../services/global.service';
import { NotificacaoService } from '../services/notificacao.service';
import { UtilitarioService } from '../services/utilitario.service';
import { MeiosDePagamentoModalComponent } from '../modals/meios-de-pagamento-modal/meios-de-pagamento-modal.component';
import { PaginatorService } from '../services/paginator.service';

declare const $: any;

@Component({
  selector: 'app-forma-de-pagamento',
  templateUrl: './forma-de-pagamento.component.html',
  styleUrls: ['./forma-de-pagamento.component.scss']
})
export class FormaDePagamentoComponent implements OnInit, OnDestroy {

  // variáveis
  formasDePagamento: FormaDePagamento[] = [];
  formasDePagamentoFiltrados: FormaDePagamento[] = [];
  carregando = true;
  campoOrdenacao = 'nome';
  ordenarDesc = false;
  editavel = true;
  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };
  listaDeItensPorPagina = [];
  itensPorPagina = 10;
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];
  status = [{ id: 0, nome: 'Bloqueado' }, { id: 1, nome: 'Ativo' }];
  statusSelecionado = 1;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  // construtor
  constructor(private formaDePagamentoService: FormaDePagamentoService, private utilitarioService: UtilitarioService,
    private router: Router, private globalService: GlobalService, private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService, private route: ActivatedRoute, public dialog: MatDialog,
    private paginatorService: PaginatorService
    ) { }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarFormasDePagamento();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.formasDePagamento = this.formasDePagamento.sort((a, b) => {
        const isAsc = !this.ordenarDesc;
        switch (this.campoOrdenacao) {
        case 'nome': return this.compare(a.descricao, b.descricao, isAsc);
        default: return 0;
        }
      });

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.formasDePagamentoFiltrados = this.formasDePagamento.filter(p => p.descricao.toLowerCase().
      includes(this.filtroNome.Valor.toString().toLowerCase()));

    if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
      this.itensPorPagina = 10;
    }

    this.paginacao.total = this.formasDePagamentoFiltrados.length;

    this.paginator.firstPage();

    this.mudaDePagina({ length: this.formasDePagamento.length, pageIndex: 0, pageSize: this.itensPorPagina });
  }

  buscarFormasDePagamento() {
    this.carregandoService.mostra('buscaFormasDePagamento');
    this.carregando = true;

    this.formaDePagamentoService.consultar(this.statusSelecionado).subscribe((data: any) => {

      this.paginator.firstPage();

      this.formasDePagamento = data;

      this.listaDeItensPorPagina = this.utilitarioService.calculaItensPorPagina(this.formasDePagamento.length);

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = this.formasDePagamento.length;

      this.mudaDePagina({ length: this.formasDePagamento.length, pageIndex: 0, pageSize: this.itensPorPagina });

      this.carregando = false;
      this.carregandoService.esconde('buscaFormasDePagamento');

    }, (erro) => {
      this.carregandoService.esconde('buscaFormasDePagamento');
      this.notificacaoService.erro(erro);
    });
  }

  novoFormaDePagamento() {
    this.router.navigate(['novo'], { relativeTo: this.route });
  }

  editarFormaDePagamento(formaDePagamento: FormaDePagamento) {
    this.router.navigate(['editar', formaDePagamento.id], { relativeTo: this.route });
  }

  bloquearFormaDePagamento(formaDePagamento: FormaDePagamento) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente bloquear a Forma de Pagamento?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('bloquearFormaDePagamento');
        this.formaDePagamentoService.bloquear(formaDePagamento.id).subscribe(resp => {
          this.notificacaoService.sucesso('Forma de Pagamento bloqueada com sucesso!!!');
          this.carregandoService.esconde('bloquearFormaDePagamento');
          this.buscarFormasDePagamento();
        }, (erro) => {
          this.carregandoService.esconde('bloquearFormaDePagamento');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.formasDePagamentoFiltrados = this.formasDePagamento.filter(p => p.descricao.toLowerCase().
      includes(this.filtroNome.Valor.toString().toLowerCase())).
      slice(pageEvent.pageIndex * pageEvent.pageSize,
        (pageEvent.pageIndex * pageEvent.pageSize) + pageEvent.pageSize);
  }

  meiosDePagamento() {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(MeiosDePagamentoModalComponent, {
      width: largura > 850 ? '800px' : (($('body').width()).toString() + 'px'),
      data: {  },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {}
    });
  }

  ngOnDestroy(): void { }
}
